import React from "react";
import POAuditReport from "../../../common/reports/audit/poAuditReport";

const POAuditIndex = props => {
  return <POAuditReport collabType="CMO" {...props} />;
};

export default POAuditIndex;
